/**
 * sl-m82f.4.2: Intelligent Search feature tab.
 * Wraps `LabeledFeatureTab` with i18n labels + the `fetchEmbeddingByDoc`
 * data source.
 */
import { useI18n } from '@affine/i18n';

import { fetchEmbeddingByDoc } from '../api';
import type { AnalyticsPeriodRange, FeatureTotals } from '../types';
import { LabeledFeatureTab } from './labeled-feature-tab';

export interface IntelligentSearchTabProps {
  workspaceId: string;
  period: string | AnalyticsPeriodRange;
  featureTotals: FeatureTotals;
}

export const IntelligentSearchTab = ({
  workspaceId,
  period,
  featureTotals,
}: IntelligentSearchTabProps) => {
  const t = useI18n();
  return (
    <LabeledFeatureTab
      cacheKey="intelligent-search"
      workspaceId={workspaceId}
      period={period}
      featureCredits={featureTotals.features.intelligentSearch}
      fetcher={fetchEmbeddingByDoc}
      docSource
      nameHeader={
        t[
          'com.streamlain.settings.workspace.ai.analytics.table.document-header'
        ]?.() ?? 'Document'
      }
      itemsLabel={
        t[
          'com.streamlain.settings.workspace.ai.analytics.card.documents-analyzed'
        ]?.() ?? 'Documents analyzed'
      }
      topLabel={
        t[
          'com.streamlain.settings.workspace.ai.analytics.card.top-document'
        ]?.() ?? 'Top document'
      }
      emptyLabel={
        t[
          'com.streamlain.settings.workspace.ai.analytics.empty.documents'
        ]?.() ?? 'No documents analyzed in this period'
      }
      countLabel={
        t[
          'com.streamlain.settings.workspace.ai.analytics.table.operations-header'
        ]?.() ?? 'Operations'
      }
    />
  );
};
